import Vuex from 'vuex'
import Vue from 'vue'
Vue.use(Vuex)

let store = new Vuex.Store({
  state: {
    answers: {
      answer1: '新北市',
      answer2: null,
      answer3: null,
      answer4: null,
      answer5: null,
    },
    isProgress: true
  },
  mutations: {
  },
  actions: {
  }
})

export default store